/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close-btn[_ngcontent-%COMP%]{background-color:#eee}.close-btn[_ngcontent-%COMP%]:hover{background-color:#ddd}.close-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:2rem}.loading-container[_ngcontent-%COMP%]{background-color:#fff;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.loading-container[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{width:8em;height:8em}.loading-container[_ngcontent-%COMP%]{height:300px}"];
export { styles as styles };
//# sourceMappingURL=edusynch-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/edusynch-modal/edusynch-modal.component.scss.shim.ngstyle.js
// module id = 1294
// module chunks = 27 28 29